import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import OrderItemTable from '@accounting/components/tables/order-item-table/order-item-table.vue';

@Component({
  name: 'bpc-order-items',
  components: {
    'bpc-order-item-table': OrderItemTable,
  },
})
export default class OrderItems extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
